module.exports = __webpack_public_path__ + "img/bgd1.767fc162.png";